import React from 'react';
import { Link } from 'react-router-dom';
import {
  Typography,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { assetUrl } from 'app/helpers/assetUrl';
import ArrowRightIcon from 'app/ui/icons/ArrowRightIcon';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'block',
    textDecoration: 'none',
    '& img': {
      display: 'block',
    },
    '& .MuiCard-root': {
      position: 'relative',
      transition: 'transform 0.2s ease-out, box-shadow 0.2s ease-out',
      boxShadow: `0px 7px 25px rgba(52, 61, 75, 0.3)`,
      transform: `translateY(-8px)`,
    },
    '&:hover .MuiCard-root': {
      boxShadow: `0px 3px 5px rgba(52, 61, 75, 0.05);`,
      transform: `translateY(0)`,
    },
    '& .icon-container': {
      color: theme.palette.info.light,
      '& svg': {
        fontSize: '2rem',
      },
    },
    '&:hover .icon-container': {
      color: theme.palette.grey[600],
    },
    /* eslint-disable */
    ['@media (hover: on-demand), (hover: none)']: {
      '& .MuiCard-root': {
        boxShadow: `0px 3px 5px rgba(52, 61, 75, 0.05);`,
        transform: `translateY(0)`,
      },
    },
  },
}));

export interface ChooseRoleListProps {
  clientRegisterLink: string;
  heroRegisterLink: string;
  headingSectionOverTitle: string;
  showAlreadyHaveAccount: boolean;
}

export default function ChooseRoleList(props: ChooseRoleListProps) {
  const classes = useStyles();

  const { clientRegisterLink, heroRegisterLink, headingSectionOverTitle } =
    props;

  return (
    <Box
      pb={2}
      pt={4}
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Container maxWidth="md" disableGutters={false}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Link to={clientRegisterLink} className={classes.root}>
              <Card>
                <Box display="flex" justifyContent="center">
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mt={2.5}
                    mr={2}
                    className="main-heading-section-tight"
                  >
                    <Typography component="h2" variant="h4">
                      Register as a
                    </Typography>
                    <Typography component="h1" variant="h1">
                      Client
                    </Typography>
                  </Box>
                  <Box mt="18px">
                    <img
                      src={assetUrl('/images/illustrations/client.svg')}
                      alt=""
                      width="100"
                      height="88"
                    />
                  </Box>
                </Box>
                <CardContent>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <ol className="simple-numbered-list">
                      <li>Register</li>
                      <li>Define Care Needs</li>
                      <li>Get Matched &amp; Relax</li>
                    </ol>
                    <div className="icon-container">
                      <ArrowRightIcon />
                    </div>
                  </Box>
                </CardContent>
              </Card>
            </Link>
          </Grid>

          <Grid item xs={12}>
            <Link to={heroRegisterLink} className={classes.root}>
              <Card>
                <Box display="flex" justifyContent="center">
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mt={2.5}
                    mr={2}
                    className="main-heading-section-tight"
                  >
                    <Typography component="h2" variant="h4">
                      Apply to be a
                    </Typography>
                    <Typography component="h1" variant="h1">
                      Hero
                    </Typography>
                  </Box>
                  <Box mt="18px">
                    <img
                      src={assetUrl('/images/illustrations/hero.svg')}
                      alt=""
                      width="100"
                      height="88"
                    />
                  </Box>
                </Box>
                <CardContent>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <ol className="simple-numbered-list">
                      <li>Apply</li>
                      <li>Onboard</li>
                      <li>Get Jobs &amp; Earn</li>
                    </ol>
                    <div className="icon-container">
                      <ArrowRightIcon />
                    </div>
                  </Box>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
